import React from 'react'
import PropTypes from 'prop-types'

import { Card } from '@components/layout/Card'

import { RemindersProvider } from './context'
import { Views } from './Views'

export const Reminders = (props) =>
  <RemindersProvider {...props}>
    <div className='wealth-manager-reminders-container'>
      <h1>Reminders</h1>
      <Card className='wealth-manager-reminders'>
        <Views />
      </Card>
    </div>
  </RemindersProvider>

Reminders.propTypes = {
  reminders: PropTypes.array.isRequired,
  remindersPath: PropTypes.string.isRequired
}
